<script lang="ts" setup>
import { onMounted } from 'vue';
import Swiper from 'swiper/bundle';
import { useI18n } from 'vue-i18n';

const t = useI18n().t;
onMounted(() => {
    new Swiper('.hero-one-slider', {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
    });
});


</script>

<template>
    <section class="hero-one-section" style="background-image: url(../../../../../assets/img/bg-two.jpg); ">
        <div class="container">
            <div class="hero-one-slider swiper">
                <div class="swiper-wrapper">
                    <div class="hero-one-text swiper-slide">
                        <h5> {{ t('Best Materials To') }} </h5>
                        <h2>{{ t('Build a House') }}</h2>
                        <p>{{ t('As a national leader in our industry') }}</p>
                        <p>{{ t('We are revolutionizing what you expect from a contractor') }}</p>
                        <div class="flex gap-1">
                            <div class="btnn">
                                <router-link :to="'/projects'" class="theme-btn w-color">{{ t('Discover Projects')
                                    }}</router-link>
                            </div>
                            <div class="btnn">
                                <a href="#estimation-calculator" class="theme-btn w-color">{{ t('Estimation Calculator')
                                    }}</a>
                            </div>
                        </div>
                        <img src="../../../assets/img/hero-two.png" alt="img">
                    </div>
                    <div class="hero-one-text swiper-slide">
                        <h5>{{ t('The Construction Quality and') }} </h5>
                        <h2>{{ t('Best Solutions') }}</h2>
                        <p>{{ t('standards, which can include safety, cost, schedule, and performance') }}</p>
                        <div class="flex gap-1">
                            <div class="btnn">
                                <router-link :to="'/projects'" class="theme-btn w-color">{{ t('Discover Projects')
                                    }}</router-link>
                            </div>
                            <div class="btnn">
                                <a href="#estimation-calculator" class="theme-btn w-color">{{ t('Estimation Calculator')
                                    }}</a>
                            </div>
                        </div>
                        <img src="../../../assets/img/hero-two-1.png" alt="img">
                    </div>
                    <div class="hero-one-text swiper-slide">
                        <h5>{{ t('We Build Your') }}</h5>
                        <h2>{{ t('Dream House') }}</h2>
                        <p>
                            {{ t('Imagine a space designed just for you—a place where every detail') }}
                            <span>{{ t('reflects your unique') }}</span><br>
                            <span>
                                {{ t('style and needs') }}.
                            </span>
                        </p>
                        <div class="flex gap-1">
                            <div class="btnn">
                                <router-link :to="'/projects'" class="theme-btn w-color">{{ t('Discover Projects')
                                    }}</router-link>
                            </div>
                            <div class="btnn">
                                <a href="#estimation-calculator" class="theme-btn w-color">{{ t('Estimation Calculator')
                                    }}</a>
                            </div>
                        </div>
                        <img src="../../../assets/img/hero-two-2.png" alt="img">
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </section>
</template>
<style lang="scss" scoped></style>